import { GetContractResponseContent } from '@/types/contract.types';
import { createApiRequest } from "../common";

/**
 * API function to retrieve a single contract by ID using the api-model
 * @param contractId ID of the contract to retrieve
 * @returns Promise with contract data
 */
export const getContractApi = async (
  contractId: string
): Promise<GetContractResponseContent> => {
  console.debug("getContractApi called with ID:", contractId);
  
  // Use the utility function to handle auth, headers, and error handling
  const request = createApiRequest<GetContractResponseContent>('post', '/getContract');
  
  try {
    console.debug("Sending request to /getContract endpoint...");
    const response = await request({ contractId });
    console.debug("getContractApi raw response structure:", {
      hasResponse: !!response,
      responseKeys: response ? Object.keys(response) : []
    });
    
    // Debug response contents
    if (response) {
      console.debug("Response keys:", Object.keys(response));
      console.debug("Response field types:", {
        contractId: typeof response.contractId,
        name: typeof response.name,
        type: typeof response.type,
        eqData: typeof response.eqData,
        iqData: typeof response.iqData,
        contractExtraction: typeof response.contractExtraction,
      });
    }
    return response;

    
  } catch (error) {
    console.error("Error in getContractApi:", error);
    throw error;
  }
};